module.exports = __webpack_public_path__ + "img/dolphin-gdbad8f1f8_1920.ed7dce39.jpeg";